import { HttpProvider } from "../http/http.provider";
import { addProvider, IProviderDescriptor, ServiceEndpointConstants } from "../ServiceUtil";
import { Observable } from "rxjs";
import { share, map } from "rxjs/operators";
import { IVendor, INewVendor, IVendorContact, IVendorResponse, INewVendorContractDocument, IVendorContractDocument, IVendorOtherContact, INewVendorBulk } from "./vendor.interface";
import { createFormData } from "../util/utilities";
import { IHttpRequestConfig } from "..";

export class VendorDelegate
{

    constructor(private http: HttpProvider)
    {
    }

    public getAllVendors(): Observable<IVendorResponse>
    {
        return this.http.get(ServiceEndpointConstants.endpoints.VENDORS.GET).pipe(
            map((response: any) =>
            {
                return {
                    vendors: this.normalizeVendors(response.data.vendors),
                    success: response.data.success
                };
            }),
            share());
    }

    public getVendorById(vendorId: string): Observable<IVendorResponse>
    {
        const config: IHttpRequestConfig = {
            params: {
                VendorId: vendorId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.VENDORS.GET_VENDOR_BY_ID, null, config).pipe(
            map((response: any) =>
            {
                return {
                    vendor: this.normalizeVendor(response.data.vendor),
                    vendorId: vendorId,
                    success: response.data.success
                };
            }),
            share());
    }


    public createNewVendor(newVendor: INewVendor): Observable<IVendorResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.VENDORS.CREATE_VENDOR, newVendor).pipe(
            map((response: any) =>
            {
                return {
                    vendors: this.normalizeVendors(response.data.vendors),
                    vendorId: response.data.vendorId,
                    success: response.data.success
                };
            }),
            share());
    }

    public createNewVendorsBulk(newBenchLead: INewVendorBulk): Observable<IVendorResponse>
    {
        const formdata = createFormData(newBenchLead);

        return this.http.post(ServiceEndpointConstants.endpoints.VENDORS.CREATE_BULK, formdata).pipe(
            map((response: any) =>
            {
                return {
                    vendors: this.normalizeVendors(response.data.vendors),
                    message: response.data.message,
                    success: response.data.success
                };
            }),
            share());
    }

    public createVendorContracts(documents: INewVendorContractDocument): Observable<IVendorResponse>
    {
        const formdata = createFormData(documents);

        return this.http.post(ServiceEndpointConstants.endpoints.VENDORS.SAVE_VENDOR_CONTRACT_DOCUMENT, formdata).pipe(
            map((response: any) =>
            {
                return {
                    vendor: this.normalizeVendor(response.data.vendor),
                    vendorId: documents.vendorId,
                    success: response.data.success
                };
            }),
            share());
    }

    public updateVendor(vendor: IVendor): Observable<IVendorResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.VENDORS.UPDATE_VENDOR, vendor).pipe(
            map((response: any) =>
            {
                return {
                    vendor: this.normalizeVendor(response.data.vendor),
                    vendorId: vendor.vendorId,
                    success: response.data.success
                };
            }),
            share());
    }

    public createOtherVendorContact(newVedorContact: IVendorOtherContact): Observable<IVendorResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.VENDORS.SAVE_OTHER_VENDOR_CONTACT, newVedorContact).pipe(
            map((response: any) =>
            {
                return {
                    vendor: this.normalizeVendor(response.data.vendor),
                    vendorOtherContactId: response.data.vendorOtherContactId,
                    success: response.data.success

                };
            }),
            share());
    }

    public updateOtherVendorContact(vedorContact: IVendorOtherContact): Observable<IVendorResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.VENDORS.UPDATE_OTHER_VENDOR_CONTACT, vedorContact).pipe(
            map((response: any) =>
            {
                return {
                    vendor: this.normalizeVendor(response.data.vendor),
                    success: response.data.success,
                    vendorOtherContactId: vedorContact.vendorOtherContactId
                };
            }),
            share());
    }


    public createVendorContact(newVedorContact: IVendorContact): Observable<IVendorResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.VENDORS.SAVE_VENDOR_CONTACT, newVedorContact).pipe(
            map((response: any) =>
            {
                return {
                    vendor: this.normalizeVendor(response.data.vendor),
                    vendorContactId: response.data.vendorContactId,
                    success: response.data.success

                };
            }),
            share());
    }

    public updateVendorContact(vedorContact: IVendorContact): Observable<IVendorResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.VENDORS.UPDATE_VENDOR_CONTACT, vedorContact).pipe(
            map((response: any) =>
            {
                return {
                    vendor: this.normalizeVendor(response.data.vendor),
                    success: response.data.success,
                    vendorContactId: vedorContact.vendorContactId
                };
            }),
            share());
    }

    private normalizeVendors(vendors: any): IVendor[]
    {
        return vendors.map(vendor =>
        {
            return this.normalizeVendor(vendor);
        });
    }

    private normalizeVendor(vendor: any): IVendor
    {
        vendor.contacts = vendor.vendorContacts.map((contact) =>
        {
            contact.vendorContactTypeId = contact.vendorContactType ? contact.vendorContactType.configurationId : '';
            contact.vendorContactType = contact.vendorContactType ? contact.vendorContactType.configurationValue : '';
            return contact;
        });
        vendor.invoiceTypeId = vendor.invoiceType ? vendor.invoiceType.configurationId : "";
        vendor.invoiceTermId = vendor.invoiceTerm ? vendor.invoiceTerm.configurationId : "";
        vendor.invoiceTemplateId = vendor.invoiceTemplate ? vendor.invoiceTemplate.configurationId : "";
        vendor.paymentTermId = vendor.paymentTerm ? vendor.paymentTerm.configurationId : "";
        vendor.paymentFollowUpTypeId = vendor.paymentFollowUpType ? vendor.paymentFollowUpType.configurationId : "";
        vendor.vendorContractDocuments = this.normalizeVendorDocuments(vendor.vendorContractDocuments ? vendor.vendorContractDocuments : []);

        delete vendor.invoiceType;
        delete vendor.invoiceTerm;
        delete vendor.invoiceTemplate;
        delete vendor.contact;
        delete vendor.paymentTerm;
        delete vendor.paymentFollowUpType;
        return vendor;
    }
    private normalizeVendorDocuments(docs: any): IVendorContractDocument[]
    {
        return docs.map(doc =>
        {
            return {
                vendorContractDocumentId: doc.vendorContractDocumentId,
                vendorContractDocumentTypeId: doc.vendorContractDocumenTypetId,
                vendorContractDocumentTypeValue: doc.vendorContractDocumenTypet ? doc.vendorContractDocumenTypet.configurationValue : "",
                fileLocationPath: doc.fileLocationPath,
                lastModifyBy: doc.lastModifyBy,
                lastModifyDateTime: doc.lastModifyDateTime,
                fileName: doc.fileName
            };
        });
    }
}